import { z } from 'zod';

export const CoreS3FileStatusSchema = z.enum(['New','Temp','Committed','Archived']);

export type CoreS3FileStatusType = `${z.infer<typeof CoreS3FileStatusSchema>}`

export default CoreS3FileStatusSchema;
